const REPORTING_VERIFIED_KEY = "ammanah_reporting_access_verified";
const REPORTING_OTP_EXPIRY_KEY = "ammanah_reporting_otp_expiry";

/**
 * Check if current session has verified reporting access
 * @returns {boolean}
 */
export const isReportingAccessVerified = () => {
  try {
    return sessionStorage.getItem(REPORTING_VERIFIED_KEY) === "true";
  } catch (e) {
    return false;
  }
};

/**
 * Mark reporting access as verified in current session
 */
export const setReportingAccessVerified = () => {
  try {
    sessionStorage.setItem(REPORTING_VERIFIED_KEY, "true");
  } catch (e) {
    console.error("Failed to store reporting verification status:", e);
  }
};

/**
 * Destroy reporting access verification and active OTP expiry
 */
export const clearReportingAccessSession = () => {
  try {
    sessionStorage.removeItem(REPORTING_VERIFIED_KEY);
    sessionStorage.removeItem(REPORTING_OTP_EXPIRY_KEY);
  } catch (e) {
    console.error("Failed to clear reporting verification session:", e);
  }
};

/**
 * Get remaining countdown seconds for OTP resend
 * @returns {number}
 */
export const getRemainingReportingOtpCountdown = () => {
  try {
    const stored = sessionStorage.getItem(REPORTING_OTP_EXPIRY_KEY);
    if (!stored) return 0;
    const diff = Math.ceil((Number(stored) - Date.now()) / 1000);
    if (diff <= 0) {
      clearReportingOtpExpiry();
      return 0;
    }
    return diff;
  } catch (e) {
    return 0;
  }
};

/**
 * Store OTP expiry timestamp
 * @param {number} seconds
 */
export const setReportingOtpExpiry = (seconds = 60) => {
  try {
    const expiry = Date.now() + seconds * 1000;
    sessionStorage.setItem(REPORTING_OTP_EXPIRY_KEY, expiry.toString());
  } catch (e) {
    console.error("Failed to store reporting OTP expiry:", e);
  }
};

/**
 * Clear stored OTP expiry
 */
export const clearReportingOtpExpiry = () => {
  try {
    sessionStorage.removeItem(REPORTING_OTP_EXPIRY_KEY);
  } catch (e) {
    console.error("Failed to clear reporting OTP expiry:", e);
  }
};
